import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import { MdOutlineMapsHomeWork } from "react-icons/md";
import { SiGoogleads } from "react-icons/si";
import { BiSolidPurchaseTag } from "react-icons/bi";
import { IoMdContacts } from "react-icons/io";
import HSAxios from "../HSAxios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "../index.css";

export default function Dashboard({ setIsLoggedIn }) {
  const [hostelData, setHosteldata] = useState({});
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get("token");

    if (!token) {
      console.log("Not logged in");
      navigate("/login", {});

      return;
    } else {
      setIsLoggedIn(true);
    }

    HSAxios.get("api/owner/dashboard", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        setHosteldata(response);
        setLoading(false);
      })
      .catch((err) => console.log("login failed, ", err));
  }, []);
  return (
    <>
      {loading && (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "70vh" }}>
          <Spinner
            animation="border"
            role="status"
            style={{
              width: "3rem",
              height: "3rem",
              borderWidth: "4px",
              borderColor: "#8B0000",
              borderRightColor: "transparent",
            }}
          />
          <p className="mt-4 fw-semibold" style={{ color: "#333", fontSize: "18px" }}>
            Loading dashboard...
          </p>
        </div>
      )}
      {!loading && (
        <div style={{ minHeight: "calc(100vh - 200px)", padding: "40px 0" }}>
          <div className="mt-4">
            <Container>
              <Row className="g-4">
                <Col md={4} className="mt-3">
                  <Card
                    className="border-0 shadow-lg"
                    style={{
                      borderRadius: "20px",
                      background: "linear-gradient(135deg, #DC143C 0%, #8B0000 100%)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      minHeight: "220px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-8px)";
                      e.currentTarget.style.boxShadow = "0 15px 40px rgba(220, 20, 60, 0.5)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 5px 20px rgba(139, 0, 0, 0.3)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <Card.Title className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="text-white fw-bold mb-0">Total Hostels</h4>
                        <MdOutlineMapsHomeWork
                          className="text-white"
                          style={{ fontSize: "50px", opacity: "0.95" }}
                        />
                      </Card.Title>
                      <Card.Text>
                        <h1 className="my-2 display-2 fw-bold text-white">
                          {hostelData.numberOfHostels || 0}
                        </h1>
                        <p className="text-white-50 small mb-0" style={{ fontSize: "14px" }}>Active hostels</p>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4} className="mt-3">
                  <Card
                    className="border-0 shadow-lg"
                    style={{
                      borderRadius: "20px",
                      background: "linear-gradient(135deg, #4A90E2 0%, #2E5C8A 100%)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      minHeight: "220px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-8px)";
                      e.currentTarget.style.boxShadow = "0 15px 40px rgba(74, 144, 226, 0.5)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 5px 20px rgba(46, 92, 138, 0.3)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <Card.Title className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="text-white fw-bold mb-0">Total Leads</h4>
                        <SiGoogleads
                          className="text-white"
                          style={{ fontSize: "50px", opacity: "0.95" }}
                        />
                      </Card.Title>
                      <Card.Text>
                        <h1 className="my-2 display-2 fw-bold text-white">
                          {hostelData.totalNumbersOfLeads || 0}
                        </h1>
                        <p className="text-white-50 small mb-0" style={{ fontSize: "14px" }}>All leads received</p>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4} className="mt-3">
                  <Card
                    className="border-0 shadow-lg"
                    style={{
                      borderRadius: "20px",
                      background: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      minHeight: "220px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-8px)";
                      e.currentTarget.style.boxShadow = "0 15px 40px rgba(16, 185, 129, 0.5)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 5px 20px rgba(5, 150, 105, 0.3)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <Card.Title className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="text-white fw-bold mb-0">Leads Purchased</h4>
                        <BiSolidPurchaseTag
                          className="text-white"
                          style={{ fontSize: "50px", opacity: "0.95" }}
                        />
                      </Card.Title>
                      <Card.Text>
                        <h1 className="my-2 display-2 fw-bold text-white">
                          {hostelData.totalPurchasedLeads || 0}
                        </h1>
                        <p className="text-white-50 small mb-0" style={{ fontSize: "14px" }}>Purchased contacts</p>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>

          <div className="mt-4">
            <Container>
              <Row className="g-4">
                <Col md={4} className="mt-3">
                  <Card
                    className="border-0 shadow-lg"
                    style={{
                      borderRadius: "20px",
                      background: "linear-gradient(135deg, #06B6D4 0%, #0891B2 100%)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      minHeight: "220px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-8px)";
                      e.currentTarget.style.boxShadow = "0 15px 40px rgba(6, 182, 212, 0.5)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 5px 20px rgba(8, 145, 178, 0.3)";
                    }}
                  >
                    <Card.Body className="p-4">
                      <Card.Title className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="text-white fw-bold mb-0">Nearby Students</h4>
                        <MdOutlineMapsHomeWork
                          className="text-white"
                          style={{ fontSize: "50px", opacity: "0.95" }}
                        />
                      </Card.Title>
                      <Card.Text>
                        <h1 className="my-2 display-2 fw-bold text-white">
                          {hostelData.totalNearbyStudents || 0}
                        </h1>
                        <p className="text-white-50 small mb-0" style={{ fontSize: "14px" }}>Students in area</p>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>

                {/* <Col md={4} className="mt-3">
                  <Card>
                    <Card.Body
                      className="rounded shadow-lg"
                      style={{ backgroundColor: "#6A40BD" }}
                    >
                      <Card.Title>
                        <h3 className="text-white fw-bold ls-tight">
                          Contact View{" "}
                        </h3>

                        <IoMdContacts
                          className="ms-2 mb-2 text-white"
                          style={{ fontSize: "40px" }}
                        />
                      </Card.Title>
                      <Card.Text>
                        <h1 className="my-2 display-3 fw-bold ls-tight text-white">
                          {hostelData.totalContactViewed || 61}
                        </h1>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col> */}
              </Row>
            </Container>
            <div className="support-box">
              <a href="/contact-us">
                <img src={`${process.env.PUBLIC_URL}/contact-us.jpg`}></img>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
